import React, { useState, useContext } from 'react';
import './ImportData.scss';
import { withTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import UploadImg from "../../../images/file_5520228.png";
import { toast } from "react-toastify";
import { LoaderContext } from '../../../App';
import KPIService from '../../../core/service/KPIService';
import { LS_REGULATION_SELECTED_KEY } from '../../../core/constants/common';
import { useSearchParams } from 'react-router-dom';
import ReportingPeriod from '../../../components/Regulation/ReportingPeriod';
import { BiX } from 'react-icons/bi';

const ImportFile = ({ t }) => {

  const glbRegulationId = localStorage.getItem(LS_REGULATION_SELECTED_KEY);
  const { setLoaderDisplay } = useContext(LoaderContext);
  const year = new Date().getFullYear();
  const [searchParams] = useSearchParams();
  const [filter, setFilter] = useState({
    reportingPeriod: searchParams.get('period') ?? `${year}-01-01`
  });
  const [filterDisplay, setFilterDisplay] = useState(true);

  const onFileSelect = (e) => {
    if (filter.reportingPeriod) {
      e.preventDefault();
      const fileUploaded = e.target.files[0];
      importFile(fileUploaded);
    } else {
      toast.warning('Please select year', {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  const importFile = (file) => {
    const formData = new FormData();
    formData.append("file", file);
    setLoaderDisplay(true);
    KPIService.uploadFile(formData, glbRegulationId, filter.reportingPeriod)
      .then((response) => {
        toast.success(response.data, {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .catch((error) => {
        setLoaderDisplay(false);
      })
      .finally(() => {
        setLoaderDisplay(false);
      });
  };

  const renderFilter = () => {
    return (
      <div className={`FileFilterBox ${filterDisplay ? 'filter-holder' : 'd-none'}`}>
        {/* <div className="filter-holder_head ">
          <h5>{t("Filter.label")}</h5>
          <div className="btnClose" onClick={() => setFilterDisplay(false)}>
            <BiX />
          </div>
        </div> */}
        <div className="filter-holder_body">
          <div className="p-2">
            <label >{t("Year.label")}</label>
            <ReportingPeriod
              defaultFrequency='ANNUAL'
              defaultPeriod={filter.reportingPeriod}
              valueChangeCallback={(period) => setReportingPeriod(`${period.year}-01-01`)} />
          </div>
          {/* <div className='p-2 text-center'>
            <Button variant='secondary' className='px-3 me-2' onClick={() => setFilterDisplay(false)}>Cancel</Button>
            <Button variant='primary' className='px-3'>Apply</Button>
          </div> */}
        </div>
      </div>
    )
  };

  const setReportingPeriod = (period) => {
    const [year, month] = period.split('-');
    const f = { ...filter, reportingPeriod: `${year}-01-01` };
    setFilter(f);
  };

  return (
    <div>
      <div className='import_customCreate_viewBox'>

        <div className='import_customBOx'>
          <h5>{t("SelectTheYearandFile.label")}</h5>
          <Button variant='secondary ' className={`px-3 ${filterDisplay ? 'd-none' : ''}`} onClick={() => setFilterDisplay(!filterDisplay)}>Filter</Button>
          {renderFilter()}
        </div>

        <div className='import_customBOx'>
          <img src={UploadImg} />
          <h5>{t("CreateImportCustomClassification.label")}</h5>

          <p>{t("SupportedFormatXlsx.label")}</p>
          <input type='file' className='file-upload-input' onChange={(e) => onFileSelect(e)}
            onClick={(e) => { e.target.value = null; }} accept=".xlsx"/>
        </div>


        {/* <div className='File_uploadView'>
              <div className='File_uploadView_in mb-2'>
                <div className='File_uploadView_box'>
                  <div className='file-image'>
                    <BiFile />
                  </div>
                  <div className='file_ulpoad_dt01'>
                    <div>
                      <h6>classification_V3.xlsx</h6>
                      <ul>
                        <li>xlsx</li>
                        <li>1.25 MB</li>
                        <li>
                          <Button className='Upladfile-action-delete'>Delete</Button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className='File_uploadView_in mb-2'>
                <div className='File_uploadView_box'>
                  <div className='file-image'>
                    <BiFile />
                  </div>
                  <div className='file_ulpoad_dt01'>
                    <div>
                      <h6>classification_V3.xlsx</h6>
                      <ul>
                        <li>xlsx</li>
                        <li>1.25 MB</li>
                        <li>
                          <Button className='Upladfile-action-delete'>Delete</Button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className='mt-2'>
                  <div className='mb-1'>
                    <span>Upload file....</span>
                    <span>Importing data</span>
                    <span>Executing equations</span>
                    <span>Success </span>
                  </div>
                  <ProgressBar animated now={45} />
                </div>
              </div>
            </div> */}

        {/* <div className='text-center p-2'>
          <Button variant='secondary' className='px-3 me-2'>Back</Button>
          <Button variant='primary' className='px-3 '>Upload</Button>
        </div> */}

      </div>
    </div>
  );
};

export default withTranslation()(ImportFile);